import { cva } from 'class-variance-authority';

export const accordionClasses = cva(['w-full gap-4 border-b border-solid border-[#E6E6E6]'], {
  variants: {
    underline: {
      true: 'border-b border-solid border-[#E6E6E6]',
      false: 'border-b-0'
    },
    iconPosition: {
      left: 'pb-2',
      right: 'pb-4'
    }
  }
});

export const accordionHeaderClasses = cva(
  [
    'font-nista-grotesk leading-sm flex cursor-pointer items-center gap-2 text-sm font-medium tracking-wide'
  ],
  {
    variants: {
      iconPosition: {
        left: 'justify-start',
        right: 'justify-between'
      }
    }
  }
);

export const accordionIconClasses = cva(
  [
    'shrink-0 fill-[#50514F] text-sm font-medium tracking-wide transition-transform duration-200 ease-in-out'
  ],
  {
    variants: {
      isOpen: {
        true: 'rotate-180'
      },
      iconPosition: {
        left: 'rotate-90',
        right: 'rotate-180'
      }
    }
  }
);

export const accordionContentClasses = cva(
  ['overflow-hidden transition-all duration-200 ease-in-out'],
  {
    variants: {
      isOpen: {
        true: 'max-h-96 pt-2',
        false: 'max-h-0 pt-0'
      },
      iconPosition: {
        left: 'ml-5',
        right: ''
      }
    }
  }
);
